import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import App from './App';
import { queryClient } from '@/lib/react-query';
import { useAuthStore } from '@/store/authStore';
import '@/styles/index.css';
// Import Antd styles for admin pages
import 'antd/dist/reset.css';

// Component to initialize auth on app start
const AuthInitializer = () => {
    const checkAuth = useAuthStore((state) => state.checkAuth);
    const token = useAuthStore((state) => state.token);

    useEffect(() => {
        // Check auth on mount if token exists
        const storedToken = localStorage.getItem('token');
        if (storedToken && !token) {
            checkAuth();
        }
    }, [checkAuth, token]);

    return null;
};

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <HelmetProvider>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <AuthInitializer />
                    <App />
                    <Toaster position="top-right" richColors closeButton />
                </BrowserRouter>
            </QueryClientProvider>
        </HelmetProvider>
    </React.StrictMode>
);
